import React from 'react'
import { User, CreditCard } from "react-feather"
import { Send } from 'react-feather'
import { useNavigate } from 'react-router-dom'

const ApplicationpaymentCard = ({title}) => {
    const navigate = useNavigate()

  return (
    <div class="card report-card">
        <div class="card-body">
            <div class="row d-flex justify-content-center">
                <div class="col-8">
                    <p class="text-dark font-weight-semibold font-14">{title}</p>
                   
                    
                    <button class="btn btn-info" onClick={() => navigate('/apply/payment-invoice')}>Invoice</button>
                    <button class="btn btn-light" onClick={() => navigate('/apply/payment')}>Make Payment</button>
                                                           
                </div>
                <div class="col-4 align-self-center">
                <div class="report-main-icon bg-light-alt">
                <CreditCard class="align-self-center icon-dual-pink icon-lg"></CreditCard> 
                    </div>
                </div>
            </div>
        </div> 
    </div>
  )
}

export default ApplicationpaymentCard